module.exports = __webpack_public_path__ + "img/m-banner-csrrksao-fr-FR.530dfc90.jpg";